const DRIVING = 'DRIVING';
const CHECKIN = 'CHECKIN';
const CHECKOUT = 'CHECKOUT';
const RETURNACCOMMODATION = 'RETURNACCOMMODATION';
const LEAVEACCOMMODATION = 'LEAVEACCOMMODATION';
const RECREATION = 'RECREATION';
const DEPARTURE = 'DEPARTURE';
const ARRIVAL = 'ARRIVAL';
const TRANSIT = 'TRANSIT';
const FLIGHTTIME = 'FLIGHTTIME';
const EAT = 'EAT';
const FREETIME = 'FREETIME';
const DAYSTART = 'DAYSTART';
const DAYEND = 'DAYEND';
const QUEUETIME = 'QUEUETIME';
const VIRTUALCHECKIN = 'VIRTUALCHECKIN';
const VIRTUALCHECKOUT = 'VIRTUALCHECKOUT';
const VIRTUALRETURNACCOMMODATION = 'VIRTUALRETURNACCOMMODATION';
const VIRTUALLEAVEACCOMMODATION = 'VIRTUALLEAVEACCOMMODATION';
const FREETIMELOCKED = 'FREETIMELOCKED';

export {
  DRIVING,
  CHECKIN,
  CHECKOUT,
  RETURNACCOMMODATION,
  LEAVEACCOMMODATION,
  RECREATION,
  DEPARTURE,
  ARRIVAL,
  TRANSIT,
  FLIGHTTIME,
  EAT,
  FREETIME,
  DAYSTART,
  DAYEND,
  QUEUETIME,
  VIRTUALCHECKIN,
  VIRTUALCHECKOUT,
  VIRTUALRETURNACCOMMODATION,
  VIRTUALLEAVEACCOMMODATION,
  FREETIMELOCKED,
};
